<template>
  <div>

    <Row class="search-con">
      <Col span="24">
          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="keyword"
          />
          <label class="search-label" >平台</label>
          <Select v-model="liveId" class="search-input"  @on-change="liveTypeChange" clearable> 
            <Option
              v-for="item in liveIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >分类</label>
          <Select v-model="classifyId" class="search-input" @on-change="classifyChange" clearable> 
            <Option
              v-for="item in classifyIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label">负责人</label>
          <Select v-model="dyId" class="search-input" clearable filterable>
            <Option
              v-for="item in userIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <Button @click="handleSearch" class="search-btn"type="primary">搜索</Button>
        </Col>
    </Row>
    <Card>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";

import { listDeleteComment, getLiveType, getClassifys, getStrategyUser} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      letterDetailFlag: false,
      tableLoading: true,
      allMoney: 0.0,
      classifyId:'',
      liveId:'',
      dyId:'',
      keyword:'',
      startTime: "",
      endTime: "",
      details:[],
      classifyIds:[],
      liveIds:[],
      userIds:[],
      columns: [
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "用户名" , key: "name", editable: true },
        { title: "分类" , key: "classifyName", editable: true },
        { title: "平台" , key: "live", editable: true },
        { title: "内容" , key: "content", editable: true },
        { title: "创建时间" , key: "create_time", editable: true }
      ],
      tableData: [],
    };
  },
  methods: {
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },liveTypeChange(value){
      if (value == undefined){
        return
      }
      this.liveId = value
      this.getStrategyUserData()

    },classifyChange(value){
      if (value == undefined){
        return
      }
      this.classifyId = value
      this.getStrategyUserData()

    },getStrategyUserData(){
      var params_ = {
        live_id: this.liveId,
        classify_id: this.classifyId
      }
      getStrategyUser(params_).then((res) => {
        var users = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          data[i] = { id: users[i].dy_id, name: users[i].username }
      }
        this.userIds = data
      });
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        dy_id: this.dyId,
        live_id: this.liveId,
        classify_id: this.classifyId,
        keyword: this.keyword
      };
      listDeleteComment(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    getLiveType({}).then((res) => {
        if (res.data.code == 200) {
          var lives = res.data.data;
          var data = new Array()
          for (var i = 0; i < lives.length; i++) {
            data[i] = { id: lives[i].id.toString(), name: lives[i].name }
          }
          this.liveIds = data
          }
      }); 

    getClassifys().then((res) => {
      var classify_list = res.data.data.records;
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    });

    this.handleSearch();
  },
};
</script>
